import PlusCircle from './PlusCircle';

export default PlusCircle;
